import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { MemoryRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../../components/Login";
import ProtectedRoute from "../../components/ProtectedRoute";
import LoginSuccess from "../../components/LoginSuccess";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute
                authenticatedElement={<LoginSuccess />}
                unauthenticatedElement={<Navigate to="/login" />}
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
